import { Link } from 'react-router-dom';
import { BarChart3, MessageSquare, UserPlus2, Wand2 } from 'lucide-react';

/**
 * One-line pointers to the features testers missed without the guided tour.
 * Static copy, no state. Shown on Agent Builder, the first screen.
 * `adminOnly` items are hidden from workspace members, who cannot use them.
 */
const items = [
  {
    icon: MessageSquare,
    text: 'Run an example agent against a persona',
    to: '/conversation-simulation',
  },
  {
    icon: UserPlus2,
    text: 'Generate adversarial personas built to break your agent',
    to: '/persona-builder',
    adminOnly: true,
  },
  {
    icon: BarChart3,
    text: 'Score each conversation against your own criteria',
    to: '/evaluations',
  },
  {
    icon: Wand2,
    text: 'Get suggestions on what to look at after a weak score',
    to: '/evaluations',
  },
];

export function WhatYouCanDo({ isAdmin }: { isAdmin: boolean }) {
  const visibleItems = items.filter((item) => isAdmin || !item.adminOnly);

  return (
    <section
      aria-label="What you can do in PromptSafe"
      className="mx-6 mt-5 rounded-[10px] border border-solid border-[#00000020] bg-prompt-safecomfantasy px-5 py-4 shadow-[0px_2px_4px_#0000001a]"
    >
      <h2 className="text-sm font-semibold text-prompt-safecomvulcan">
        What you can do here
      </h2>
      <ul className="mt-2 grid gap-x-6 gap-y-1.5 text-sm text-prompt-safecomabbey sm:grid-cols-2">
        {visibleItems.map(({ icon: Icon, text, to }) => (
          <li key={text} className="flex items-center gap-2">
            <Icon className="h-4 w-4 flex-none text-prompt-safecomoutrageous-orange" />
            <Link to={to} className="hover:underline">
              {text}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
